import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { DURATION_TIME } from '../../constants';

import { createTasks } from '../../Repositories';

const taskReq = createTasks();

/**
 * this function(query) is to get All Tasks
 * @function useTasksGetQuery
 * @param {Object} reqParams params pass along with the api call
 * @param {Object} options to be passed as query handling
 * @returns api response
 */
export function useTasksGetQuery(reqParams, options) {
  return useQuery(['taskGetQuery', reqParams], () => taskReq.getAllTasks(reqParams), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    refetchInterval: DURATION_TIME,
    refetchIntervalInBackground: true,
    ...options,
  });
}

/**
 * this function(query) is to put task by Id
 * @function useTaskPutQueryById
 * @returns api response
 */
export function useTaskPutQueryById() {
  const queryClient = useQueryClient();
  return useMutation(['taskPutQueryById'], (args) => taskReq.putTaskById(args), {
    retry: false,
    meta: { successToast: false },
    onSuccess: () => {
      queryClient.invalidateQueries(['taskGetQuery']);
      queryClient.invalidateQueries(['notesGetQuery']);
    },
  });
}
export function useTaskPutQueryByNoteId() {
  const queryClient = useQueryClient();
  return useMutation(['taskPutQueryByNoteId'], (args) => taskReq.putTaskByNoteId(args), {
    retry: false,
    meta: { successToast: false },
    onSuccess: () => {
      queryClient.invalidateQueries(['taskGetQuery']);
      queryClient.invalidateQueries(['notesGetQuery']);
    },
  });
}

async function markTasksInBatches(tasks, batchSize = 10) {
  for (let i = 0; i < tasks.length; i += batchSize) {
    const batch = tasks.slice(i, i + batchSize);
    // eslint-disable-next-line no-await-in-loop
    await Promise.all(
      batch.map((task) => taskReq.putTaskById({ reqId: task.id, reqBody: { status: 'COMPLETED' } }))
    );
  }
}

export function useTasksMarkAllComplete() {
  const queryClient = useQueryClient();
  return useMutation(['tasksMarkAllComplete'], (tasks) => markTasksInBatches(tasks), {
    retry: false,
    meta: { successToast: false },
    onSuccess: () => {
      queryClient.invalidateQueries(['taskGetQuery']);
      queryClient.invalidateQueries(['notesGetQuery']);
    },
  });
}
